<script setup lang="ts">
import { useTemplateRef } from 'vue';

import { useLongScroll } from '@libs/utils';

import TheFooter from '../../core/components/theFooter/TheFooter.vue';

interface TripOverviewPageLayoutEmits {
  (eventName: 'long-scroll'): void;
}
const emit = defineEmits<TripOverviewPageLayoutEmits>();

const tripOverviewPageLayoutRef = useTemplateRef<HTMLElement>(
  'tripOverviewPageLayoutRef'
);

const { longScrollEvent } = useLongScroll(tripOverviewPageLayoutRef);

longScrollEvent.subscribe(() => emit('long-scroll'));
</script>

<template>
  <div ref="tripOverviewPageLayoutRef" class="trip-overview-page-layout">
    <div class="content-wrapper">
      <div class="left-column">
        <slot name="leftColumn" />
      </div>
      <div class="right-column">
        <slot name="rightColumn" />
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<style scoped lang="scss">
.trip-overview-page-layout {
  display: flex;
  flex-direction: column;

  min-height: 100vh;
  min-height: 100dvh;

  //NOTE: This rule prevents the overview scrollbar from appearing behind some elements in Safari.
  transform: translateZ(0);

  .content-wrapper {
    box-sizing: border-box;
    margin: 0 auto;
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
    width: 100%;
    background-color: var(--color-off-white);

    .left-column {
      padding-bottom: var(--spacing-24);

      @include for-less-or-equal-than-1199-px {
        grid-template-columns: minmax(0, auto);
      }
    }

    .right-column {
      position: sticky;
      top: 0;
      height: 100vh;
      box-shadow: var(--shadow-elevation-100);

      @include for-less-or-equal-than-1199-px {
        position: static;
        height: auto;
        box-shadow: unset;
      }
    }

    @include for-less-or-equal-than-1199-px {
      grid-template-columns: minmax(0, auto);
    }
  }

  @include for-less-or-equal-than-899-px {
    background-color: var(--color-white);
  }
}
</style>

<style lang="scss">
* {
  box-sizing: border-box;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track {
  @include for-less-or-equal-than-1199-px {
    background: var(--color-off-white);
  }
}
</style>
